import { Injectable } from '@angular/core';
import { bcAuthEvents } from 'common/common/constants/auth-events';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { ReplaySubject } from 'rxjs';
import { CommonAuthService } from 'common/auth/common-auth.service';

@Injectable()
export class LoginSubscriber {
  private subject: ReplaySubject<boolean>;

  constructor(private RxEmitter: RxEmitter, private commonAuthService: CommonAuthService) {
    this.subject = new ReplaySubject<boolean>(1);
    this.RxEmitter
      .subscribe(bcAuthEvents.loginSuccess, () => this.subject.next(true));

    if (this.commonAuthService.isLoggedIn()) {
      this.subject.next(true);
    }
  }

  subscribe(callback) {
    return this.subject
      .subscribe(callback);
  }
}
